/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const CrossIcon = createIcon({
    displayName: 'CrossIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "m4.905 19.995 7.066-7.066 7.036 7.061.943-.943-7.037-7.061 7.043-7.043L19.012 4l-7.04 7.041L4.955 4l-.943.943 7.017 7.041-7.067 7.068.942.943Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M23.707 1.707 22.293.293 12 10.586 1.707.293.293 1.707 10.586 12 .293 22.293l1.414 1.414L12 13.414l10.293 10.293 1.414-1.414L13.414 12 23.707 1.707Z"
        })
    ]
});
CrossIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'CrossIcon'
};
export { CrossIcon };

//# sourceMappingURL=cross.js.map